import { css } from 'styled-components';
import { getColorShade } from '../../../src/styled/utils';
export default css `
  color: ${({ $shade = 'highEmphasis' }) => getColorShade('onSurface', $shade)};
`;
